import * as React from 'react'
import { ReactElement } from 'react'
import { Modal } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'

type CloseModalProps = {
  showCloseModal?: boolean
  setShowCloseModal?: (e: boolean) => void
  onConfirm?: () => void
  onCancel?: () => void
}

export const CloseModal = ({
  showCloseModal,
  setShowCloseModal,
  onConfirm,
  onCancel,
}: CloseModalProps): ReactElement => {
  const { t } = useTranslation()

  const translate = (key: string, variable?: any) =>
    t(`consent.createConsentForms.${key}`, variable)

  return (
    <Modal
      localisation={{
        title: translate('components.modal.warning'),
        confirmText: t(`general.buttons.confirm`),
        cancelText: t(`general.buttons.cancel`),
      }}
      onConfirm={onConfirm}
      onCancel={onCancel}
      setIsModalVisible={setShowCloseModal}
      // @ts-ignore
      isModalVisible={showCloseModal}
    >
      <>
        <div style={styles.archiveModalRow1}>
          {translate('components.modal.yourProgress')}
        </div>
        <div style={styles.archiveModalRow2}>
          {translate('components.modal.row2')}
        </div>
      </>
    </Modal>
  )
}

const styles = {
  archiveModalRow1: {
    fontSize: 14,
  },
  archiveModalRow2: {
    fontWeight: 700,
    fontSize: 14,
  },
}

export default CloseModal
